<template>
  <v-data-table
    :headers="headers"
    :items="items"
    hide-default-footer
    item-key="id"
    class="insurance-table"
    fixed-header
    height="calc(100vh - 228px)"
  >
    <template v-slot:item.name="{ item }">
      <div class="name-cell">
        {{ item.name }}
      </div>
    </template>
    <template v-slot:item.action="{ item }">
      <div class="action-cell">
        <div class="toggle-wrapper">
          <div
            v-for="option in actionOptions"
            :key="option.value"
            class="toggle-btn"
            :class="{ active: item.action === option.value }"
            @click="item.action = option.value"
          >
            {{ option.label }}
          </div>
        </div>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "InsuranceTable",
  props: {
    employee: {
      type: Object,
      default: () => ({}),
    },
    call: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        {
          text: this.$t("payroll_information_status"),
          value: "name",
          align: "right",
        },
        {
          text: "",
          value: "action",
          align: "left",
          sortable: false,
          width: 260,
        },
      ],
      actionOptions: [
        { label: this.$t("new"), value: "new" },
        { label: this.$t("edit"), value: "edit" },
        { label: this.$t("not_send"), value: "not_send" },
      ],

      staticItem: { id: "all-personnel", name: "همه پرسنل", action: "new" },
      personnel: [],
    };
  },
  watch: {
    employee: {
      immediate: true,
      handler(val) {
        if (val && val.items) {
          this.personnel = val.items.map((item, index) => ({
            id: `emp-${item.id}-${index}`,
            name: `${item.DSW_FNAME} ${item.DSW_LNAME}`,
            action: "new",
          }));
        }
      },
    },
    call: {
      immediate: true,
      handler(val) {
        if (val) {
          this.downloadFile();
        }
      },
    },
  },
  computed: {
    items() {
      return [this.staticItem, ...this.personnel];
    },
  },
  mounted() {},
  methods: {
    downloadFile() {
      const app = this;
      app.loading = true;
      const id_ = app.$route.query.id;
      app.$axios
        .get(app.$endpoint + "salary/tax/" + id_, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          // create a blob from response
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // create a link element
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // set file name
          link.download = "tax_data.txt";
          // trigger download
          link.click();
          // cleanup
          window.URL.revokeObjectURL(link.href);
          this.$emit("stop-loading");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.insurance-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 5px;
}
.insurance-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.insurance-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}
.insurance-table ::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}
.insurance-table ::v-deep tbody tr {
  height: 35px;
}
.insurance-table ::v-deep .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
  overflow-y: auto;
}
.insurance-table ::v-deep td {
  padding: 6px 18px !important;
}
.insurance-table ::v-deep th:first-child {
  text-align: right;
}
.insurance-table ::v-deep thead th {
  font-size: 16px !important;
  font-weight: 600;
  color: #444;
}
.insurance-table {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.toggle-wrapper {
  display: flex;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  overflow: hidden;
  /* width: fit-content; */
  background: #fff;
}
.toggle-btn {
  padding: 4px 8px;
  font-size: 13px;
  cursor: pointer;
  color: #555;
  background: #fff;
  border-right: 1px solid #dcdcdc;
}
.toggle-btn:first-child {
  border-left: none;
}
.name-cell {
  width: 100%;
  text-align: right;
}
.action-cell {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.toggle-btn.active {
  background-color: #e8f8ef;
  color: #1b7f4b;
  font-weight: 500;
}
.name-text {
  font-size: 13px;
  color: #333;
}
</style>
